














import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'

@Component({
  components: {
    BaseButton
  }
})
export default class ActionShowButton extends Vue {
  @Prop({ required: true }) url!: string
  @Prop({ default: 'مشاهده' }) label?: string
}
